 <template>
  <div>
    <div
      id="registeradd"
      ref="registeradd"
      :style="{ width: '100%', height: '260px' }"
    ></div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
require("echarts/lib/component/dataZoom");
require("echarts/lib/component/grid");
require("echarts/lib/chart/line");
// require('echarts/lib/component/markPoint');
// require('echarts/lib/component/axisPointer');

export default {
  props: {
    regBaseMom: { Type: Array, default: () => {} },
  },

  data() {
    return {
      regBase: this.regBaseMom,
    };
  },
  created() {
    console.log(this.regBase, "regBase");
  },
  mounted() {
    this.register();
  },
  watch: {
    // 实际业务中，当子组件值改变时，有时候也会通知父组件，这时我们也要监听子组件的数据变化
    manageBasereg(val) {
      this.$emit("searchdate", val);
      // /
    },
  },
  methods: {
    register() {
      // let myChart = echarts.init(document.getElementById("registeradd"));
      if (this.$refs.registeradd) {
        setTimeout(() => {
          // 基于准备好的dom，初始化echarts实例
          let myChart = echarts.init(this.$refs.registeradd);
          // 绘制图表
          myChart.setOption({
            title: {
              text: this.regBase.name,
              left: "center",
              top: 0,
              textStyle: {
                //文字颜色
                color: "#666666",
                //字体风格,'normal','italic','oblique'
                fontStyle: "normal",
                fontSize: 18,
              },
            },
            // dataZoom: [
            //   {
            //     // type: 'inside',
            //     show: true,
            //     realtime: true,
            //     start: 0,
            //     endValue: 3,
            //     zoomLock: false,
            //     fillerColor: "#ccc",
            //     background: "none",
            //     backgroundColor: "#e8eaef",
            //     showDataShadow: false, //是否显示数据阴影 默认auto
            //     showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
            //     filterMode: "empty",
            //     bottom: 0,
            //     height: 7,
            //     cursor: "pointer",
            //     textStyle: false
            //   }
            // ],
            color: ["#90aef5", "#59b1f1"],
            tooltip: {
              trigger: "axis",
              textStyle: {
                align: "left",
              },
              axisPointer: {
                type: "line",
              },
              formatter: "{b0}<br/>{a0}:{c0}<br/>{a1}:{c1}",
            },
            legend: {
              data: ["计划产值", "完成产值"],
              top: 30,
              textStyle: {
                //文字颜色
                color: "#666666",
                //字体风格,'normal','italic','oblique'
                fontStyle: "normal",
                fontSize: 14,
              },
            },
            grid: {
              x: 45,
              y: 70,
              x2: 45,
              y2:30,
            },
            xAxis: [
              {
                type: "category",
                data: this.regBase.date,
                axisLine: {
                  lineStyle: {
                    color: "#666", // 颜色
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "计划产值",
                min: 0,
                max: Math.max.apply(null, this.regBase.vcont1.map(Number)) + 20,
                interval:
                  parseInt(
                    Math.max.apply(null, this.regBase.vcont1.map(Number)) + 20
                  ) / 5,
                axisLabel: {
                  formatter: "{value}",
                },
                axisLine: {
                  lineStyle: {
                    color: "#666", // 颜色
                  },
                },
              },
              {
                type: "value",
                name: "完成产值",
                min: 0,
                max: Math.max.apply(null, this.regBase.vcont2.map(Number)) + 20,
                interval:
                  parseInt(
                    Math.max.apply(null, this.regBase.vcont2.map(Number)) + 20
                  ) / 5,
                axisLabel: {
                  formatter: "{value} ",
                },
                axisLine: {
                  lineStyle: {
                    color: "#666", // 颜色
                  },
                },
              },
            ],
            series: [
              {
                name: "计划产值",
                type: "line",
                symbolSize: 2,
                // barWidth: 30,
                data: this.regBase.vcont1,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      color: "#00a5eb",
                    },
                  },
                },
              },
              {
                name: "完成产值",
                type: "line",
                yAxisIndex: 1,
                symbolSize: 2,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      color: "#dd6161",
                    },
                  },
                },
                data: this.regBase.vcont2,
              },
            ],
          });
        }, 0);
      }
    },
  },
};
</script>
